module.exports = __webpack_public_path__ + "img/20.43d5199b.jpg";